import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles({
  content: {
    "& .MuiFormControl-root": {
      marginTop: "10px"
    },
    "& > span": {
      fontSize: "14px",
      lineHeight: "18px"
    }
  }
});

export default function Purpose({ modulePurpose, change }) {
  const { content } = useStyles();
  return (
    <div className={content}>
      <span>Цели реализации модуля</span>
      <TextField
        multiline
        rows={5}
        fullWidth
        onChange={e => change("purpose", e.target.value)}
        value={(modulePurpose && modulePurpose.data.purpose) || ""}
		InputLabelProps={{
              shrink: true
            }}
      />
    </div>
  );
}
